var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCpuCharge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 60,
    viewBox: "0 0 61 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M38 10H23C16.1 10 10.5 15.6 10.5 22.5V37.5C10.5 44.4 16.1 50 23 50H38C44.9 50 50.5 44.4 50.5 37.5V22.5C50.5 15.6 44.9 10 38 10ZM43.65 35.65C43.65 39.8 40.3 43.15 36.15 43.15H24.85C20.7 43.15 17.35 39.8 17.35 35.65V24.35C17.35 20.2 20.7 16.85 24.85 16.85H36.125C40.275 16.85 43.625 20.2 43.625 24.35V35.65H43.65Z",
    fill: "#004192"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1501 6.875V10H23.0001C21.7501 10 20.5501 10.175 19.4001 10.525V6.875C19.4001 5.85 20.2251 5 21.2751 5C22.3001 5 23.1501 5.85 23.1501 6.875Z",
    fill: "#004192"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.375 6.875V10H28.625V6.875C28.625 5.85 29.475 5 30.5 5C31.525 5 32.375 5.85 32.375 6.875Z",
    fill: "#004192"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M41.625 6.875V10.525C40.475 10.175 39.25 10 38 10H37.875V6.875C37.875 5.85 38.725 5 39.75 5C40.775 5 41.625 5.85 41.625 6.875Z",
    fill: "#004192"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M55.5001 20.7501C55.5001 21.8001 54.6751 22.6251 53.6251 22.6251H50.5001V22.5001C50.5001 21.2501 50.3251 20.0251 49.9751 18.8751H53.6251C54.6751 18.8751 55.5001 19.7251 55.5001 20.7501Z",
    fill: "#004192"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M55.5 30C55.5 31.025 54.675 31.875 53.625 31.875H50.5V28.125H53.625C54.675 28.125 55.5 28.95 55.5 30Z",
    fill: "#004192"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M55.5001 39.2499C55.5001 40.2749 54.6751 41.1249 53.6251 41.1249H49.9751C50.3251 39.9749 50.5001 38.7499 50.5001 37.4999V37.3749H53.6251C54.6751 37.3749 55.5001 38.1999 55.5001 39.2499Z",
    fill: "#004192"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M41.625 49.4751V53.1251C41.625 54.1501 40.775 55.0001 39.75 55.0001C38.725 55.0001 37.875 54.1501 37.875 53.1251V50.0001H38C39.25 50.0001 40.475 49.8251 41.625 49.4751Z",
    fill: "#004192"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3999 50V53.125C32.3999 54.15 31.5499 55 30.5249 55C29.4749 55 28.6499 54.15 28.6499 53.125V50H32.3999Z",
    fill: "#004192"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1501 50.0001V53.1251C23.1501 54.1501 22.3001 55.0001 21.2751 55.0001C20.2251 55.0001 19.4001 54.1501 19.4001 53.1251V49.4751C20.5501 49.8251 21.7501 50.0001 23.0001 50.0001H23.1501Z",
    fill: "#004192"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M11.025 18.8751C10.675 20.0251 10.5 21.2501 10.5 22.5001V22.6251H7.375C6.35 22.6251 5.5 21.8001 5.5 20.7501C5.5 19.7251 6.35 18.8751 7.375 18.8751H11.025Z",
    fill: "#004192"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 28.125V31.875H7.375C6.35 31.875 5.5 31.025 5.5 30C5.5 28.95 6.35 28.125 7.375 28.125H10.5Z",
    fill: "#004192"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M11.025 41.1249H7.375C6.35 41.1249 5.5 40.2749 5.5 39.2499C5.5 38.1999 6.35 37.3749 7.375 37.3749H10.5V37.4999C10.5 38.7499 10.675 39.9749 11.025 41.1249Z",
    fill: "#004192"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1501 16.85H24.8501C20.7001 16.85 17.3501 20.2 17.3501 24.35V35.625C17.3501 39.775 20.7001 43.125 24.8501 43.125H36.1251C40.2751 43.125 43.6251 39.775 43.6251 35.625V24.35C43.6501 20.225 40.2751 16.85 36.1501 16.85ZM34.4751 32.6L32.1251 36.7C31.7751 37.3 31.1501 37.65 30.5001 37.65C30.1751 37.65 29.8501 37.575 29.5751 37.4C28.6751 36.875 28.3751 35.725 28.8751 34.85L30.5751 31.9H29.1001C27.9001 31.9 26.9251 31.375 26.4001 30.475C25.8751 29.575 25.9251 28.45 26.5001 27.425L28.8501 23.325C29.3751 22.425 30.5251 22.125 31.4001 22.625C32.3001 23.15 32.6001 24.3 32.1001 25.175L30.4001 28.125H31.8751C33.0751 28.125 34.0501 28.65 34.5751 29.55C35.1251 30.45 35.0751 31.55 34.4751 32.6Z",
    fill: "#004192"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCpuCharge);
export default __webpack_public_path__ + "static/media/cpu-charge.f1bc45af021af1e2e6ed95a8c7f4b541.svg";
export { ForwardRef as ReactComponent };